import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import i18n from "./i18n";

import "./helpers/directives/index";

import DashboardPlugin from "./plugins/dashboard-plugin";
Vue.use(DashboardPlugin);

import VueSelectSides from "vue-select-sides-forked";
Vue.use(VueSelectSides);
Vue.component("vue-select-sides", VueSelectSides);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
  store,
  i18n,
});
